var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-select"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$tr('vacancy.settings.talentq.select-acc')))]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }